import React from 'react';
import { WalkerReviews } from '../../../../types/api';
import { WalkerSectionContainer } from '../WalkerServices/WalkerCollapsible/WalkerSectionContainer';
import { WalkerServiceReview } from '../WalkerReviews/WalkerServiceReview';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
type Props = {
  endorsements: WalkerReviews['items'];
  totalEndorsements?: number;
  hasMoreData: boolean;
  error?: boolean;
  isEndorsementsClamped?: boolean;
  isFetchingData?: boolean;
  containerProps?: BoxProps;
  onClampButtonClick?: () => void;
};
const MAX_ENDORSEMENTS_TO_SHOW = 3;
export const WalkerServiceEndorsements = ({
  endorsements,
  hasMoreData,
  isEndorsementsClamped,
  error,
  isFetchingData,
  onClampButtonClick,
  totalEndorsements,
  containerProps
}: Props) => {
  const endorsementsCount = endorsements && endorsements.length;
  const isClampButtonVisible = hasMoreData || isEndorsementsClamped || endorsementsCount > MAX_ENDORSEMENTS_TO_SHOW;
  const emptyEndorsements = !endorsements?.length || error;
  return <Box {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerServiceEndorsements" data-sentry-source-file="WalkerServiceEndorsements.tsx">
      <WalkerSectionContainer title={!emptyEndorsements ? <>
              {totalEndorsements > 1 ? ' Endorsements' : ' Endorsement'}
            </> : null} isFetchingData={isFetchingData} containerProps={{
      pt: 0
    }} data-sentry-element="WalkerSectionContainer" data-sentry-source-file="WalkerServiceEndorsements.tsx">
        <Box display="flex" flexDirection="column" style={{
        rowGap: '20px'
      }} data-sentry-element="Box" data-sentry-source-file="WalkerServiceEndorsements.tsx">
          {!emptyEndorsements ? endorsements.map(endorsement => <WalkerServiceReview key={endorsement?.createdAt} review={endorsement} />) : <Box fontSize="14px" fontFamily="muli" color="#272727">
              No endorsements available
            </Box>}
        </Box>

      </WalkerSectionContainer>
      {isClampButtonVisible && <Button variant="text" mt="8px" ml="calc(50% - 30px)" disabled={isFetchingData} onClick={onClampButtonClick} fontFamily="muliSemiBold">
          {hasMoreData || isEndorsementsClamped ? 'Show more' : 'Show less'}
        </Button>}
    </Box>;
};